<template>
    <v-container class="gradient-bg" fluid style="height:100%;">
        <v-row align="center" justify="space-around" style="height:100%">
            <v-col align="center" cols="12" md="6">
                <v-card max-width="500">
                    <v-card-title class="headline">Set Up Two-Factor Authentication</v-card-title>
                    <v-card-text>
                        <p>Scan the QR code below with your authenticator app.</p>
                        <v-img :src="qrCodeUrl" contain></v-img>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" @click="confirmTotp">Confirm</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>    
import { supabase } from '../supabase'
export default {
    data() {
        return {
            qrCodeUrl: '',
            secret: ''
        }
    },
    async created() {
        const { data, error } = await supabase.auth.mfa.enroll({
            factorType: 'totp',
            friendlyName: 'Sigma Equity Authenticator'
        })
        console.log('Enrolled TOTP:',error);
        
        // Use the id to create a challenge.
        // The challenge can be verified by entering the code generated from the authenticator app.
        // The code will be generated upon scanning the qr_code or entering the secret into the authenticator app.
        // const { id, type, totp: { qr_code, secret, uri }, friendly_name } = data
        this.qrCodeUrl = data.totp.qr_code
        // console.log(id, type, secret, uri, friendly_name);
        
        // const challenge = await supabase.auth.mfa.challenge({ factorId: id });
        // console.log('Challenge created:', challenge);
    },
    methods: {
        async confirmTotp() {
            this.$store.commit('SET_SETUP_TOTP', false)
            this.$store.commit('SET_VERIFY_TOTP', true)
            // const { error } = await supabase.auth.setTotp(this.secret)
            // if (error) {
            //     console.error('Error confirming TOTP:', error)
            //     return
            // }
            // this.$store.commit('SET_SETUP_TOTP', true)
            // this.$router.push('/dashboard')
        }
    }
}
</script>